import { render, staticRenderFns } from "./InteractiveInfo.vue?vue&type=template&id=28afe8af&scoped=true&"
import script from "./InteractiveInfo.vue?vue&type=script&lang=js&"
export * from "./InteractiveInfo.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveInfo.vue?vue&type=style&index=0&id=28afe8af&prod&scoped=true&lang=scss&"
import style1 from "./InteractiveInfo.vue?vue&type=style&index=1&id=28afe8af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28afe8af",
  null
  
)

export default component.exports